// extracted by mini-css-extract-plugin
module.exports = {"breakpointSM":"576px","breakpointMD":"768px"};